import { render, staticRenderFns } from "./Paypal.vue?vue&type=template&id=619fc459&"
import script from "@/scripts/Mall/Paypal/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/Paypal/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports